import { atom } from "recoil"
import { MatchingOffersModel } from "../../../types/matching/matchingOfferModel"

export const otherOffersState = atom<MatchingOffersModel[]>({
  key: "atoms/matching/otherOffersState",
  default: undefined,
})
